// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ki-0";
export var fileList = "_ki-2";
export var removeFileButton = "_ki-1";